export interface FFProps {
  blMaintenanceMode: boolean;
  v2ColorSchemes: boolean;
  v2Development: boolean;
  v2FieldWalkthroughs: boolean;
  v2Jobs: boolean;
  v2ManageTools: boolean;
  v2MapSetup: boolean;
  v2ModelHomes: boolean;
  v2Neighborhoods: boolean;
  v2Options: boolean;
  v2Parts: boolean;
  v2PhotoApproval: boolean;
  v2Plans: boolean;
  v2Possessions: boolean;
  v2ProductionChecklists: boolean;
  v2ProductionPunchlists: boolean;
  v2Reports: boolean;
  v2ScheduleTemplates: boolean;
  v2ShowBuildTools: boolean;
  v2Specs: boolean;
  v2Users: boolean;
  v2ShowTradePartnerContracts: boolean;
  v2SiteReports: boolean;
  zendeskAndHelpTools: boolean;
  entraId: boolean;
  salesClosingCalendar: boolean;
  underContract: boolean;
  clientViewBuild: boolean;
  clientBuildCreation: boolean;
  fwtManagement: boolean;
  contractMarkUp: boolean;
  homeownerClosingCeremonies: boolean;
  closingDateSageOverwrite: boolean;
  salesDigitalContracting: boolean;
  documentationBuildDocumentation: boolean;
  uniformLoginPage: boolean;
  unifiedUserManagement: boolean;
  bulkOptionExclusions: boolean;
  selectsPageSlidingMenus: boolean;
  salesTestBuild: boolean;
  salesAgentLookup: boolean;
  salesIncentiveRepeater: boolean;
  entraUserCreationOrigin: boolean;
  hidePlaceOrderPage: boolean;
  convertToEntraButton: boolean;
  createReturnPoButton: boolean;
  lotPremiumOptionDepositCalculation: boolean;
  manageAppRolesPage: boolean;
  authorizeUserNavigationAccess: boolean;
  fwtPlanMarkup: boolean;
  homeownerPortalV2: boolean;
  buildCommunicationsPage: boolean;
  warrantyQuestionPage: boolean;
}

// note when adding/removing flags from here also update the list found at the root, index.tsx to update which
// flags are evaulated
export enum FeatureFlag {
  v2ShowTradePartnerContracts = 'v2ShowTradePartnerContracts',
  v2ProductionChecklists = 'v2ProductionChecklists',
  v2FieldWalkthroughs = 'v2FieldWalkthroughs',
  v2ProductionPunchlists = 'v2ProductionPunchlists',
  v2ShowTradePartnerBidManagement = 'v2ShowTradePartnerBidManagement',
  v2ShowBuildTools = 'v2ShowBuildTools',
  v2Development = 'v2Development',
  v2Neighborhoods = 'v2Neighborhoods',
  v2Possessions = 'v2Possessions',
  v2Specs = 'v2Specs',
  v2ColorSchemes = 'v2ColorSchemes',
  v2Plans = 'v2Plans',
  v2ManageTools = 'v2ManageTools',
  v2Users = 'v2Users',
  v2Placeholder = 'v2Placeholder',
  v2Jobs = 'v2Jobs',
  v2Parts = 'v2Parts',
  v2Options = 'v2Options',
  v2Reports = 'v2Reports',
  v2ModelHomes = 'v2ModelHomes',
  v2MapSetup = 'v2MapSetup',
  v2PhotoApproval = 'v2PhotoApproval',
  v2ScheduleTemplates = 'v2ScheduleTemplates',
  blMaintenanceMode = 'blMaintenanceMode',
  v2SiteReports = 'v2SiteReports',
  zendeskAndHelpTools = 'zendeskAndHelpTools',
  entraId = 'entraId',
  salesClosingCalendar = 'salesClosingCalendar',
  underContract = 'underContract',
  clientViewBuild = 'clientViewBuild',
  clientBuildCreation = 'clientBuildCreation',
  fwtManagement = 'fwtManagement',
  contractMarkUp = 'contractMarkUp',
  homeownerClosingCeremonies = 'homeownerClosingCeremonies',
  closingDateSageOverwrite = 'closingDateSageOverwrite',
  salesDigitalContracting = 'salesDigitalContracting',
  documentationBuildDocumentation = 'documentationBuildDocumentation',
  uniformLoginPage = 'uniformLoginPage',
  unifiedUserManagement = 'unifiedUserManagement',
  bulkOptionExclusions = 'bulkOptionExclusions',
  selectsPageSlidingMenus = 'selectsPageSlidingMenus',
  salesTestBuild = 'salesTestBuild',
  salesAgentLookup = 'salesAgentLookup',
  salesIncentiveRepeater = 'salesIncentiveRepeater',
  entraUserCreationOrigin = 'entraUserCreationOrigin',
  hidePlaceOrderPage = 'hidePlaceOrderPage',
  convertToEntraButton = 'convertToEntraButton',
  createReturnPoButton = 'createReturnPoButton',
  lotPremiumOptionDepositCalculation = 'lotPremiumOptionDepositCalculation',
  manageAppRolesPage = 'manageAppRolesPage',
  authorizeUserNavigationAccess = 'authorizeUserNavigationAccess',
  fwtPlanMarkup = 'fwtPlanMarkup',
  homeownerPortalv2 = 'homeownerPortalV2',
  buildCommunicationsPage = 'buildCommunicationsPage',
  warrantyQuestionPage = 'warrantyQuestionPage'
}
